export default {
      id: "icon-heart-left-usage",
      viewBox: "0 0 627 814",
      url: __webpack_public_path__ + "icons.svg#icon-heart-left",
      toString: function () {
        return this.url;
      }
    }